import { TrashIcon } from '@radix-ui/react-icons'
import { useMutation, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'
import { PageCard, PageLayout, PageTwoColumn } from '@/components/ui/page'
import { usePrompt } from '@/components/ui/prompt'

import { accountMasterDetail } from '@/features/account/api'
import {
	AccountStatusBadge,
	RoleBadge,
} from '@/features/account/components/common'

export const Route = createFileRoute('/_app/settings/user/$id/')({
	loader: async ({ context: { qc }, params: { id } }) => {
		await qc.ensureQueryData(accountMasterDetail.qry({ id }))
		return
	},
	component: Component,
})

function Component() {
	const { id } = Route.useParams()
	const qry = useSuspenseQuery(accountMasterDetail.qry({ id }))
	const { account } = qry.data

	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/settings', 'Pengaturan'],
					['/settings/user', 'Pengguna'],
					['/settings/user/$id', account.name],
				]}
			/>
			<PageTwoColumn>
				<PageTwoColumn.Main>
					<PageCard.Root>
						<PageCard.Header
							title="Detail Pengguna"
							actions={
								<PageCard.HeaderAction asChild>
									<Link from={Route.fullPath} to="/settings/user/$id/edit">
										Edit
									</Link>
								</PageCard.HeaderAction>
							}
						/>
						<PageCard.ContentRow title="Nama" value={account.name} />
						<PageCard.ContentRow title="Email" value={account.email} />
						<PageCard.ContentRow
							title="Role"
							value={<RoleBadge role={account.role} />}
						/>
						<PageCard.ContentRow
							title="Status"
							value={<AccountStatusBadge status={account.status} />}
						/>
					</PageCard.Root>
				</PageTwoColumn.Main>
				<PageTwoColumn.Sidebar>
					<SectionRemoveAccount />
				</PageTwoColumn.Sidebar>
			</PageTwoColumn>
		</PageLayout.Root>
	)
}

function SectionRemoveAccount() {
	// const { account, refetchOnRemove } = Route.useLoaderData()
	const navigate = Route.useNavigate()
	const prompt = usePrompt()

	const { mutateAsync, isPending } = useMutation({
		mutationFn: async () => {
			// await accountApiRemove(account.id)
			// await refetchOnRemove()
			navigate({ to: '/settings/user', replace: true })
			return true
		},
	})

	const onRemove = async () => {
		const res = await prompt({
			title: 'Konfirmasi Penghapusan Akun',
			description: 'Apakah Anda yakin ingin menghapus akun ini?',
		})

		if (!res) return

		await mutateAsync()
	}

	return (
		<PageCard className="divide-none">
			<PageCard.Header
				title="Hapus Akun"
				actions={
					<Button
						variant="danger"
						size="small"
						onClick={onRemove}
						isLoading={isPending}
					>
						<TrashIcon />
						Hapus
					</Button>
				}
			/>
		</PageCard>
	)
}
